import { Action, ActionReducer } from '@ngrx/store';

/**
 * Reducer manages loading error addition.
 */
export const errorAdd: ActionReducer<object> = (state: object = {}, {type, payload}: ErrorAction) => {
    return {...state, [type]: payload};
};

/**
 * Reducer manages loading error removal.
 */
export const errorRemove: ActionReducer<object> = (state: object = {}, {type}: ErrorAction) => {
    return Object.keys(state)
        .filter(key => key !== type)
        .reduce((obj, key) => {
            obj[key] = state[key];
            return obj;
        }, {});
};

/**
 * Action represents change of loading error.
 *
 * Type is currently performed action.
 * Payload represents http error returned by angular http client.
 */
export class ErrorAction implements Action {
    constructor(public type: string, public payload?: object) {}
}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/loading-error.reducer.ts